import apiInstance from "api";

// Location-scoped Environmental subscriptions (flex2-api). CLIENT orgs are
// billed per site; independent VENDOR orgs per whole org. Internal grant model
// — no Stripe. Admin endpoints are super-admin gated; getMine is per-user.
export const EnvironmentalSubscriptionsApiService = {
  // body: { organizationId, locationId?, planUuid, term, trialDays?, notes? }
  assign: (body) => apiInstance.post("/environmental-subscriptions/assign", body),
  // body: { subscriptionId, term }
  renew: (body) => apiInstance.post("/environmental-subscriptions/renew", body),
  // body: { subscriptionId, reason? }
  revoke: (body) => apiInstance.post("/environmental-subscriptions/revoke", body),
  list: (organizationId) =>
    apiInstance.get("/environmental-subscriptions", { params: { organizationId } }),
  // The caller's own current subscription (or null) — feeds the sidebar card.
  getMine: () => apiInstance.get("/environmental-subscriptions/me"),
  // ECC gate: is every site at/below the picker location subscribed? Any
  // authenticated user; returns { covered, uncoveredSites: [{id,name}] }.
  coverage: (siteId) =>
    apiInstance.get("/environmental-subscriptions/coverage", {
      params: siteId != null ? { siteId } : {},
    }),
};

export default EnvironmentalSubscriptionsApiService;
